// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"BlogPage_pageContainer__2NysY","pageBody":"BlogPage_pageBody__Mkntp","underline":"BlogPage_underline__2nGSj"};